export default "__VITE_ASSET__sJr6RqGg__"